import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue"
import App from "./App.vue"
import Antd from "ant-design-vue"
import router from "./router/index"
import store from "./store/index"
import "ant-design-vue/dist/antd.css"
import "./public.css"
import "./app.css";
import MetaInfo from 'vue-meta-info'

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(MetaInfo);

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount("#app");

Vue.directive('scroll', {
  // 当绑定元素插入到 DOM 中
  inserted: function (el, binding) {
    var cb = binding.value;
    function wheelHandler(e) {
      var direction = (-e.wheelDelta || e.detail) > 0 ? true : false
      cb(direction)
    }
    try {
      el.addEventListener('mousewheel', wheelHandler) || el.addEventListener("DOMMouseScroll", wheelHandler);
    } catch (e) {
      el.attachEvent("mousewheel", wheelHandler);
    }
  }
})